<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<a id="page_ii"></a>
<h1 class="title">The End of Mr. Garment</h1>
<p class="subtitle">Book Three of the Walter Ghost Mysteries</p>
<p class="author">Vincent Starrett</p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?48692cca